var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37461 5C9.37461 3.80977 8.89928 2.7303 8.12778 1.94144C7.85627 1.66367 7.38962 1.74561 7.22643 2.09803C7.1299 2.3067 7.17018 2.55391 7.33059 2.7178C7.90731 3.30666 8.26354 4.11254 8.26354 5C8.26354 6.4055 7.37017 7.60546 6.12161 8.06412V7.69851C6.12161 7.44123 5.84315 7.28012 5.62024 7.40894L3.91718 8.39223C3.69427 8.52105 3.69427 8.84256 3.91718 8.97138L5.62024 9.95467C5.84315 10.0835 6.12161 9.92238 6.12161 9.6651V9.22935C7.99411 8.73389 9.37461 7.0284 9.37461 5Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73607 5C1.73607 3.60248 2.61902 2.40774 3.85613 1.94317V2.30149C3.85613 2.55877 4.13459 2.71988 4.3575 2.59106L6.06055 1.60777C6.28346 1.47895 6.28346 1.15744 6.06055 1.02862L4.3575 0.0453287C4.13459 -0.0834858 3.85613 0.0776192 3.85613 0.334901V0.776551C1.99474 1.27931 0.625 2.97959 0.625 5C0.625 6.20759 1.11422 7.30061 1.90551 8.09224C2.17876 8.36584 2.64124 8.28355 2.80374 7.93253C2.90095 7.72246 2.85929 7.47247 2.69541 7.30894C2.10307 6.71764 1.73607 5.90101 1.73607 5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.4ec8e052863bcbe58b547096eeffbc57.svg";
export { ForwardRef as ReactComponent };